
export enum EmailDirectionTypeCd {
	INBOUND = 'Inbound',
	OUTBOUND = 'Outbound'}

